// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--b7561";
export var title = "main-module--title--216c2";